/* eslint-disable import/no-cycle */
/* eslint-disable arrow-body-style */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable max-len */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
import React, { memo, useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import Environments from "../../Environments";

import BaseFrame from "../../component/wrapper/BaseFrame";
import { ZINDEX_BASE } from "../../component/Theme";
import SompoLoading from "../../component/loading/SompoLoading";
import { HomeLink } from "../../component/breadcrums/Links";
import ChangePasswordModal, { PasswordValues } from "./changePassword/ChangePasswordModal";
import ChangeSubMailaddressDialog, { SubMailaddressValues } from "./changeSubMailaddress/ChangeSubMailaddressDialog";
import History from "./History";

import SompoContext from "../../logic/context/SompoContext";
import UserDetailService, { UserDetailPayload, UserDetailResponse } from "../../logic/api/UserDetailService";
import { openInformationDialog, showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { logout } from "../../logic/logout";
import { concatPeriod } from "../../logic/datetime";
import OnGoingGridListService, { OnGoingGridListItem, OnGoingGridListResponse } from "../../logic/api/OnGoingGridListService";
import ResultGridListService, { ResultGridListItem, ResultGridListResponse } from "../../logic/api/ResultGridListService";
import OnGoingCULGridListService, { OnGoingCULGridListResponse, OnGoingCULGridListItem } from "../../logic/api/OnGoingCULGridListService";
import ResultCULGridListService, { ResultCULGridListResponse, ResultCULGridListItem } from "../../logic/api/ResultCULGridListService";
import { Categories, useCategories2 } from "../../logic/hook/useCategories";

import { CAREER_TYPE_ELEARNING, CAREER_TYPE_CLASSROOM } from "../../Constants";

// Logics.
const onGoingCareerService = new OnGoingGridListService();
const resultCareerService = new ResultGridListService();
const onGoingCULService = new OnGoingCULGridListService();
const resultCULService = new ResultCULGridListService();
const service = new UserDetailService();

// Interfaces/Types
export interface CareerHistoryProfile extends Partial<OnGoingGridListItem>, Partial<ResultGridListItem> {
    careerId: string;
    careerTypeId: string;
    classId: string;
    jissiKikan: string;
    status: string;
}
export interface CurriculumHistoryProfile extends Partial<OnGoingCULGridListItem>, Partial<ResultCULGridListItem> {}

// 共通サービス...パスワード変更、サブメールアドレス変更
export const saveUserDetail = async (
    userDetail: UserDetailResponse,
    payload: Partial<UserDetailPayload>,
    onSaved: () => void,
    onError: (error: unknown) => void
) => {
    await service.saveUserDetail(
        {
            ...{
                password: "",
                rePassword: "",
                lang: userDetail.lang,
                familyNameJa: userDetail.familyNameJa,
                timeZone: userDetail.timeZone,
                fileData: "",
                fileType: "",
                firstNameJa: userDetail.firstNameJa,
                familyNameKanaJa: userDetail.familyNameKanaJa,
                firstNameKanaJa: userDetail.firstNameKanaJa,
                addressJa: userDetail.addressJa,
                homePhone: userDetail.homePhone,
                faxNumber: userDetail.faxNumber,
                email1: userDetail.email1,
                email2: userDetail.email2,
                careerMemoJa: userDetail.careerMemoJa,
                countryCode: userDetail.countryCode,
                lederUserId: userDetail.lederUserId,
                deleteImage: userDetail.deleteImage,
            },
            ...payload,
        } as UserDetailPayload,
        onSaved,
        (error: any) => {
            console.error(error);
            onError(error);
        }
    );
};

const fetchProfile = async (
    fetchCategories: () => Promise<Categories>
): Promise<{
    userDetail: UserDetailResponse;
    careerHistories: CareerHistoryProfile[];
    showCurriculums: boolean;
    curriculumHistoriesOnGoing: OnGoingCULGridListItem[];
    curriculumHistoriesResult: ResultCULGridListItem[];
}> => {
    /* =================================
     * ユーザ情報
     * ================================= */
    let userDetail = {} as UserDetailResponse;
    await service.getUserDetail(
        (response: UserDetailResponse) => {
            userDetail = response;
        },
        (error: any) => {
            console.error(error);
            showErrorMessage({
                message: "ユーザ情報の取得に失敗しました。",
                error,
            });
            throw error;
        }
    );

    /* =================================
     * カテゴリ
     * ================================= */
    const _categories: Categories = await fetchCategories();
    const { showCurriculums: showCurriculumsFn } = _categories;

    /* =================================
     * 受講履歴(講座)
     * ================================= */
    // 実施中
    const onGoingHistories: CareerHistoryProfile[] = await onGoingCareerService
        .fetch()
        .then((response: OnGoingGridListResponse) => response.onGoingGridList)
        .catch((error: unknown) => {
            showErrorMessage({
                message: "受講履歴の取得に失敗しました。",
                error,
            });
            throw error;
        });

    // 実績
    const resultHistories: CareerHistoryProfile[] = await resultCareerService
        .fetch()
        .then((response: ResultGridListResponse) => {
            // eラーニングの実施実績期間{開始日}と{終了日}があれば結合してjissiKikanに入れる
            // 集合講座は実施期間：{実施期間開始日} ～ {実施期間終了日}をjissiKikanに入れる
            // 未実施、受講期間外などその他ステータスは空欄
            const mapped = (response.resultGridList || []).map((history) => {
                const careerType = history.careerTypeId;
                let jissiKikan = "";
                switch (careerType) {
                    case CAREER_TYPE_ELEARNING:
                        jissiKikan = concatPeriod(history.startDate, history.endDate);
                        break;
                    case CAREER_TYPE_CLASSROOM:
                        jissiKikan = concatPeriod(history.jissiStartDateODT, history.jissiEndDateODT);
                        break;
                    default:
                        break;
                }
                return {
                    ...history,
                    jissiKikan,
                };
            });
            return mapped;
        })
        .catch((error: unknown) => {
            showErrorMessage({
                message: "受講履歴の取得に失敗しました。",
                error,
            });
            throw error;
        });

    const careerHistories: CareerHistoryProfile[] = [...onGoingHistories, ...resultHistories];

    /* =================================
     * 受講履歴(カリキュラム)
     * ================================= */
    // カリキュラムを表示するか
    const showCurriculums = showCurriculumsFn();

    // カリキュラムを表示する場合だけ、受講履歴をfetch
    const curriculumHistoriesOnGoing = showCurriculums
        ? await onGoingCULService
              .fetch()
              .then((response: OnGoingCULGridListResponse) => response.onGoingCULGridList || [])
              .catch((error: any) => {
                  showErrorMessage({
                      message: "受講履歴の取得に失敗しました。",
                      error,
                  });
                  throw error;
              })
        : [];
    const curriculumHistoriesResult = showCurriculums
        ? await resultCULService
              .fetch()
              .then((response: ResultCULGridListResponse) => response.resultCULGridList || [])
              .catch((error: any) => {
                  showErrorMessage({
                      message: "受講履歴の取得に失敗しました。",
                      error,
                  });
                  throw error;
              })
        : [];

    return {
        userDetail,
        careerHistories,
        showCurriculums,
        curriculumHistoriesOnGoing,
        curriculumHistoriesResult,
    };
};

// モーダルをヘッダーの上に表示させるため、divでzIndexを指定する
const Profile = () => {
    const [modalOpen, setModalOpen] = useState<boolean>(false); // モーダルをヘッダー上に表示させる用
    const [passChangeModalOpen, setPassChangeModalOpen] = useState<boolean>(false); // パスワード変更モーダル用
    const [subAddresModalOpen, setSubAddresModalOpen] = useState<boolean>(false); // サブメールアドレス変更モーダル用
    const theme = useTheme();

    const PassChangeButton = (userDetail: UserDetailResponse) => {
        const [password, setPassword] = useState<PasswordValues>({
            password: "",
            rePassword: "",
        });
        const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);

        // 「パスワードを変更する」ボタン押下時
        const openPasswordModal = () => {
            setModalOpen(true);
            setPassChangeModalOpen(true);
        };

        // パスワード変更ダイアログを閉じる
        const closePasswordModal = () => {
            setModalOpen(false);
            setPassChangeModalOpen(false);
            setPassword({
                password: "",
                rePassword: "",
            });
        };

        // パスワード変更成功時
        const clearPasswordFieldsOnSuccess = () => {
            setPassword({
                password: "",
                rePassword: "",
            });
        };

        // 入力時
        const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
            setPassword({ ...password, [event.target.name]: event.target.value });
        };

        /**
         * バリデーションチェック
         * @returns true: バリデーションエラー, false: エラーなし
         */
        const validation = () => {
            if (password.password !== password.rePassword) {
                showErrorMessage({ message: "新しいパスワード、新しいパスワード(再入力)が一致していません。" });
                return true;
            }
            return false;
        };

        // 「変更」ボタン押下時（新パスワード登録）
        const changePassword = () => {
            if (validation()) return;
            if (!Environments.MOCK) {
                const _fetch = async () => {
                    await saveUserDetail(
                        userDetail,
                        {
                            password: password.password,
                            rePassword: password.rePassword,
                        },
                        () => setChangePasswordSuccess(true),
                        (error: any) => {
                            const messages = (error.message || "").split(":");
                            const message = messages[0];
                            if (message === "ERROR_PASSWORD_POLICY") {
                                showErrorMessage({
                                    message: messages[1],
                                    error,
                                });
                            } else {
                                console.error(error);
                                showErrorMessage({ message: "パスワードの変更に失敗しました。", error });
                            }
                        }
                    );
                };
                void _fetch();
            } else {
                setChangePasswordSuccess(true);
            }
        };

        useEffect(() => {
            if (changePasswordSuccess) {
                clearPasswordFieldsOnSuccess();
                openInformationDialog({
                    message: "パスワードを変更しました。\nログイン画面を表示します。",
                    resolve: () => {
                        setChangePasswordSuccess(false);
                        logout();
                    },
                });
            }
        }, [changePasswordSuccess]);

        return (
            <>
                <Button
                    sx={{
                        transition: "all 0.2s ease-in-out",
                        width: "100%",
                        border: `2px solid ${theme.palette.primary.main}`,
                        marginY: "8px",
                    }}
                    onClick={openPasswordModal}
                >
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                        パスワードを変更する
                    </Typography>
                </Button>
                <ChangePasswordModal
                    open={passChangeModalOpen}
                    values={password}
                    handleChange={handleChangePassword}
                    handleClose={closePasswordModal}
                    register={changePassword}
                />
            </>
        );
    };

    const SubAddressChangeButton = (props: {
        userDetail: UserDetailResponse;
        renderCount: number;
        setRenderCount: React.Dispatch<React.SetStateAction<number>>;
    }) => {
        const { userDetail, renderCount, setRenderCount } = props;
        const [subMailaddress, setSubMailaddress] = useState<SubMailaddressValues>({
            subMailaddress: "",
        });
        const [changeSubMailaddress, setChangeSubMailaddress] = useState(false);

        // 「サブメールアドレスを変更する」ボタン押下時
        const openSubAddressModal = () => {
            setSubAddresModalOpen(true);
            setModalOpen(true);
        };

        // サブメールアドレス変更ダイアログを閉じる
        const closeSubAddressModal = () => {
            setModalOpen(false);
            setSubAddresModalOpen(false);
            setSubMailaddress({
                subMailaddress: "",
            });
        };

        // 入力時
        const handleChangeSubMailaddress = (event: React.ChangeEvent<HTMLInputElement>) => {
            setSubMailaddress({
                ...subMailaddress,
                [event.target.name]: event.target.value,
            });
        };

        /**
         * バリデーションチェック
         * @returns true: バリデーションエラー, false: エラーなし
         */
        const validation = () => {
            if (subMailaddress.subMailaddress === userDetail.email2) {
                showErrorMessage({
                    message: "新しいサブメールアドレスと現在のサブメールアドレスが同じです。新しいサブメールアドレスを再度入力してください。",
                });
                return true;
            }
            return false;
        };

        // 「変更」ボタン押下時（新サブメールアドレス登録）
        const changeSubAdrress = () => {
            if (validation()) return;
            if (!Environments.MOCK) {
                const _fetch = async () => {
                    await saveUserDetail(
                        userDetail,
                        {
                            email2: subMailaddress.subMailaddress,
                        },
                        () => setChangeSubMailaddress(true),
                        (error: any) => {
                            showErrorMessage({
                                message: "サブメールアドレスの変更に失敗しました。",
                                error,
                            });
                        }
                    );
                };
                void _fetch();
            } else {
                setChangeSubMailaddress(true);
            }
        };

        useEffect(() => {
            if (changeSubMailaddress) {
                closeSubAddressModal();
                openInformationDialog({
                    message: "サブメールアドレスを変更しました。",
                    resolve: () => {
                        setChangeSubMailaddress(false);
                        setRenderCount(renderCount + 1);
                    },
                });
            }
        }, [changeSubMailaddress]);

        return (
            <>
                <Button
                    sx={{
                        transition: "all 0.2s ease-in-out",
                        width: "100%",
                        border: `2px solid ${theme.palette.primary.main}`,
                        marginY: "8px",
                    }}
                    onClick={openSubAddressModal}
                >
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                        サブメールアドレスを変更する
                    </Typography>
                </Button>
                <ChangeSubMailaddressDialog
                    open={subAddresModalOpen}
                    values={subMailaddress}
                    handleChange={handleChangeSubMailaddress}
                    handleClose={closeSubAddressModal}
                    register={changeSubAdrress}
                />
            </>
        );
    };

    // 実際に表示されるコンポーネント
    const Content = () => {
        const [careers, setCareers] = React.useState<CareerHistoryProfile[]>([]);
        const [onGoingCurriculums, setOnGoingCurriculums] = React.useState<CurriculumHistoryProfile[]>([]);
        const [resultCurriculums, setResultCurriculums] = React.useState<CurriculumHistoryProfile[]>([]);
        const [renderCount, setRenderCount] = useState<number>(0);
        const [userDetail, setUserDetail] = useState<UserDetailResponse>({} as UserDetailResponse);
        const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用
        const [showCurriculums, setShowCurriculums] = React.useState(false);
        const { fetchCategories } = useCategories2();

        const primaryOrgId = userDetail?.primaryOrgId;
        const userOrgs = userDetail?.userOrgs || [];
        let userOrgName = "";
        userOrgs.forEach((org) => {
            if (primaryOrgId === org?.orgId) {
                userOrgName = org?.orgName || "";
            }
        });

        useEffect(() => {
            // ローディング表示開始
            sompoContext.setLoading(true);

            // fetch
            const _fetch = async () => {
                try {
                    const {
                        userDetail: _userDetail,
                        careerHistories,
                        showCurriculums: _showCurriculums,
                        curriculumHistoriesOnGoing: _curriculumHistoriesOnGoing,
                        curriculumHistoriesResult: _curriculumHistoriesResult,
                    } = await fetchProfile(fetchCategories);

                    // Set States.
                    setUserDetail(_userDetail);
                    setCareers(careerHistories);
                    setShowCurriculums(_showCurriculums);
                    setOnGoingCurriculums(_curriculumHistoriesOnGoing);
                    setResultCurriculums(_curriculumHistoriesResult);

                    // ローディング終了
                    sompoContext.setLoading(false);
                } catch (error: any) {
                    // Set States.
                    setUserDetail({} as UserDetailResponse);
                    setCareers([]);
                    setOnGoingCurriculums([]);
                    setResultCurriculums([]);

                    // ローディング終了
                    sompoContext.setLoading(false);
                }
            };
            void _fetch();
        }, [renderCount]);

        const UserDataArea = () => {
            // 項目ごとのDOM
            const UserDataRow = (dateProps: { label: string; value: string }) => {
                const { label, value } = dateProps;
                return (
                    <>
                        <Grid item container direction="row" alignItems="center" flexWrap="nowrap">
                            <Grid item xs={5} sm={4} md={3} sx={{ fontWeight: "bold" }}>
                                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {label}
                                </Typography>
                            </Grid>
                            <Grid item xs={7} sm={8} md={9}>
                                {(value || "").split("\n").map((line, index) => {
                                    if (line) {
                                        return (
                                            <Typography variant="h6" key={`UserDataRow-${label}-${index}`} sx={{ overflowWrap: "break-word" }}>
                                                {line}
                                            </Typography>
                                        );
                                    }
                                    return (
                                        <Typography
                                            variant="h6"
                                            key={`UserDataRow-${label}-${index}`}
                                            sx={{ overflowWrap: "break-word" }}
                                            dangerouslySetInnerHTML={{
                                                __html: "&nbsp;",
                                            }}
                                        />
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </>
                );
            };

            // 実際のDOM
            return (
                <Grid container sx={{ p: { xs: 2, sm: 2, md: 4 }, mb: 2, bgcolor: "white", borderRadius: "4px", position: "relative" }}>
                    <>
                        <Grid item xs={12} sm={8} md={8} container direction="column">
                            <UserDataRow label="氏名" value={`${userDetail?.familyNameJa || ""} ${userDetail?.firstNameJa || ""}`} />
                            <UserDataRow label="氏名(カナ)" value={`${userDetail?.familyNameKanaJa || ""} ${userDetail?.firstNameKanaJa || ""}`} />
                            <UserDataRow label="組織" value={userOrgName} />
                            <UserDataRow label="メールアドレス" value={userDetail?.email1 || ""} />
                            <UserDataRow label="サブメールアドレス" value={userDetail?.email2 || ""} />
                        </Grid>
                        <Grid
                            item
                            xs
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                padding: { xs: 1, sm: 2, md: 5 },
                                borderLeft: { xs: "none", sm: "2px solid #ddd", md: "2px solid #ddd" },
                            }}
                        >
                            <Grid item container direction="column">
                                <PassChangeButton {...userDetail} />
                                <SubAddressChangeButton userDetail={userDetail} renderCount={renderCount} setRenderCount={setRenderCount} />
                            </Grid>
                        </Grid>
                    </>
                </Grid>
            );
        };

        return (
            <>
                {sompoContext.loading ? (
                    <SompoLoading />
                ) : (
                    <Grid container direction="column" justifyContent="center">
                        <UserDataArea />
                        <History
                            careers={careers}
                            onGoingCurriculums={onGoingCurriculums}
                            resultCurriculums={resultCurriculums}
                            showCurriculums={showCurriculums}
                        />
                    </Grid>
                )}
            </>
        );
    };

    return (
        <div style={modalOpen ? { position: "relative", zIndex: ZINDEX_BASE } : { position: "relative" }}>
            <BaseFrame width="75%" title="マイページ" breadcrumbs={[<HomeLink />]} content={<Content />} />
        </div>
    );
};

export default memo(Profile);
